import { z } from "zod"

export const GROUPINGS = ["ata_chapter", "type"] as const

export const groupingSchema = z.enum(GROUPINGS)

export type Grouping = z.infer<typeof groupingSchema>

export const GROUPING_LABELS: Record<Grouping, string> = {
  ata_chapter: "ATA chapter",
  type: "Type",
}
